import request from '@/utils/request'

//引入
// import touristApi from '@/api/system/home/home.js'

//使用
// homeApi.houseCustomTagList().then((res) => {
//   if (res.code == 200) {
//     this.$message.success('查询房源自定义标签列表')
//     this.customTagList = res.data
//   }
// })

export default {
  // 首页统计
  statistics(query) {
    return request({
      url: '/home/statistics',
      method: 'get',
      params: query
    })
  },

  // 查询学习管理信息列表
  getLearnList(query) {
    return request({
      url: '/system/learningManagerInfo/list',
      method: 'get',
      params: query
    })
  },

  // 房源热度
  houseLookHot(query) {
    return request({
      url: '/houseInfo/houseLookHot',
      method: 'get',
      params: query
    })
  },

}